import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { UrgencyBar } from './UrgencyBar';
import { heroFacts, mockups, offer, offerAnchor } from '../data/content';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section id="top" className="w-full bg-cream pb-16 md:pb-20" data-id="element-66" data-mp="4lqjixa15f41">
      <UrgencyBar data-id="element-67" data-mp="4njqkdok21ck" />

      <div className="mx-auto w-full max-w-content px-5 pt-12 text-center md:px-8 md:pt-16" data-id="element-68" data-mp="4jvup7vn12uo">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease
      }} className="inline-flex items-center rounded-full border border-forest-200 bg-white px-4 py-2 font-sans text-[0.7rem] font-bold uppercase tracking-[0.16em] text-forest-600" data-id="element-69" data-mp="127ecf87a1fat">
          Basado en Proverbios y Eclesiastés
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.03,
        ease
      }} className="mx-auto mt-7 font-sans text-sm font-bold uppercase tracking-[0.22em] text-gray-400 md:text-base" data-id="element-70" data-mp="3cz5v8bjvq00c">
          Biblioteca de Sabiduría de Salomón
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.05,
        ease
      }} className="mx-auto mt-4 max-w-4xl font-display text-[2.35rem] font-extrabold leading-[1.04] tracking-tight text-ink sm:text-5xl md:text-[3.5rem]" data-id="element-71" data-mp="399bctsb4jly3">
          <span className="text-forest-600" data-id="element-72" data-mp="35a2jupnwrs3l">130+ Mapas de Sabiduría Antigua</span> para Decidir sin
          Miedo, Hablar sin Arrepentirte y Vivir en Paz
        </motion.h1>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease
      }} src={mockups.kit} alt="El Ecosistema de Salomón: los 4 tomos, el libro principal, los mapas visuales, la hoja de ejercicio y la versión para celular con 130+ mapas" className="mx-auto mt-8 w-full max-w-2xl md:mt-10" width={1024} height={1024} data-id="element-73" data-mp="2vjq0h0rty4z1" />

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.16,
        ease
      }} className="mx-auto mt-8 max-w-3xl" data-id="element-74" data-mp="ibgmsx9dfpla">
          <p className="mx-auto max-w-2xl text-lg leading-relaxed text-gray-500 md:text-xl" data-id="element-75" data-mp="1azkufobi6cqm">
            Principios de Proverbios y Eclesiastés transformados en mapas visuales sencillos, para
            que consultes en unos minutos cuando necesites dirección.
          </p>

          <div className="mt-9" data-id="element-76" data-mp="x1w8ed5p8zjz">
            <CtaButton size="xl" href={offerAnchor} data-id="element-77" data-mp="x0l3ub4fjnrt">
              {offer.cta}
            </CtaButton>
          </div>

          <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-sm font-semibold text-gray-500" data-id="element-78" data-mp="3lqug7stmcf76">
            {heroFacts.map((fact, index) => <li key={fact} className="inline-flex items-center gap-3" data-id="element-79" data-mp="1xavxukzeea7s" data-mpi={index}>
                {index > 0 && <span className="h-1 w-1 rounded-full bg-forest-600" aria-hidden="true" data-id="element-80" data-mp="21b63txn6x0mn" />}
                {fact}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}